// Fireflies' pink-purple for calls and Outlook blue for emails, as a tint and a straight bar along the header's foot,
// which never meets the card's rounded corners.
export const SOURCE_HEADER: Record<'call' | 'email', string> = {
  call: 'rounded-t-etn-card border-b-[3px] border-b-fuchsia-500 bg-fuchsia-50',
  email: 'rounded-t-etn-card border-b-[3px] border-b-blue-600 bg-blue-50',
}
